import Controller from 'controllers/controller';
import Animator from 'tools/animator';
import Elements from 'tools/elements';

class MobileNavController extends Controller {
    ready() {
        this.elements = new Elements();

        this.options = {
            offset : -10,
            openDuration : 0.1,
            closeDuration : 0.05,
            stagger : 0.06
        };

        this.cacheElements();
        this.attachEvents();
    }

    cacheElements() {
        this.elements.queryOne('navigation', '#mobile-nav-container');
        this.elements.queryOne('navigationInner', '.mobile-nav-content');
        this.elements.queryOne('mobileNavButton', '#mobile-nav-button');
        this.elements.queryAll('bars', '#mobile-nav-button span');

        this.elements.queryAll('dropdowns', '#mobile-nav-container .dropdown');
        this.elements.queryAll('dropdownTriggers', '#mobile-nav-container .dropdown-trigger');

        this.elements.each('dropdowns', dropdown => {
            dropdown.__cachedTrigger = dropdown.querySelector('#mobile-nav-container .dropdown-trigger');
            dropdown.__cachedUl = dropdown.querySelector('ul');
            dropdown.__cachedLi = dropdown.__cachedUl.children;
        });

        this.elements.navigation.style.display = 'block';

        this.elements.each('dropdownTriggers', dropdownTrigger => {
            let dropdown = dropdownTrigger.parentNode;

            if(dropdownTrigger.parentNode.classList.contains('open')) {
                // In case of responsive hiding
                dropdown.style.display = 'block';

                this.openDropdown(dropdownTrigger, false);

                dropdown.style.display = '';
            } else {
                this.closeDropdown(dropdownTrigger, false);
            }
        });

        this.elements.navigation.style.display = '';

        this.elements.queryOne('navigationTrigger','.navigation-trigger');
        this.elements.queryAll('secondaryNavigationTriggers', '.secondary-navigation-trigger');
    }

    attachEvents() {
        this.elements.each('dropdownTriggers', dropdownTrigger => {
            dropdownTrigger.removeEventListener('click', this.onDropdownTriggerClick);
            dropdownTrigger.addEventListener('click', this.onDropdownTriggerClick);
        });

        this.elements.navigationTrigger.removeEventListener('click', this.onNavigationTriggerClick);
        this.elements.navigationTrigger.addEventListener('click', this.onNavigationTriggerClick);

        this.elements.each('secondaryNavigationTriggers', trigger => trigger.addEventListener('click', this.onTriggerClick));

        window.addEventListener('resize', this.onWindowResize);
    }

    onWindowResize() {
        if (document.body.classList.contains('navigation-open') && ! this.elements.mobileNavButton.offsetWidth) {
            this.closeNavigation();
        }
    }

    onTriggerClick() {
        this.toggleNavigation();
    }

    onDropdownTriggerClick(event) {
        let dropdownTrigger = event.currentTarget,
            dropdown = dropdownTrigger.parentNode;

        if(dropdown.classList.contains('open')) {
            this.closeDropdown(dropdownTrigger);
        } else {
            this.elements.each('dropdowns', drop => {
                if(drop.classList.contains('open') && dropdown !== drop) {
                    this.closeDropdown(drop.__cachedTrigger);
                }
            });

            this.openDropdown(dropdownTrigger);
        }
    }

    onNavigationTriggerClick() {
        this.toggleNavigation();
    }

    toggleNavigation() {
        if (document.body.classList.contains('navigation-open')) {
            this.closeNavigation();
        } else {
            this.openNavigation();
        }
    }

    openDropdown(dropdownTrigger, animate) {
        let dropdown = dropdownTrigger.parentNode,
            ul = dropdown.__cachedUl,
            lis = dropdown.__cachedLi,
            lisLength = lis.length,
            height = 0,
            duration = this.options.openDuration,
            index,
            width,
            widest = 0;

        if(typeof animate === 'undefined') {
            animate = true;
        }

        TweenLite.set(ul, {
            height: 0
        });

        for(index = 0; index < lisLength; ++index) {
            height += lis[index].offsetHeight;

            width = lis[index].offsetWidth;

            if(width > widest) {
                widest = width;
            }

            TweenLite.set(lis[index], {
                y: -height,
                opacity: 0,
                rotation: 0.000
            });

            TweenLite.to(lis[index], animate ? duration + (index * this.options.stagger) : 0, {
                y: 0,
                opacity: 1,
                rotation: 0.001,
                ease: Power3.easeOut
            });
        }

        TweenLite.set(dropdownTrigger, {
            rotation: 0
        });

        TweenLite.to(ul, animate ? duration + (index * this.options.stagger) : 0, {
            height: height,
            ease: Power3.easeOut
        });

        TweenLite.to(dropdownTrigger, animate ? 0.2 : 0, {
            rotation: 90,
            ease: Power3.easeOut
        });

        dropdown.classList.add('open');
    }

    closeDropdown(dropdownTrigger, animate) {
        let dropdown = dropdownTrigger.parentNode,
            ul = dropdown.__cachedUl,
            lis = dropdown.__cachedLi,
            lisLength = lis.length,
            height = 0,
            duration = this.options.closeDuration,
            index,
            width = 0,
            widest = 0;

        if(typeof animate === 'undefined') {
            animate = true;
        }

        for(index = 0; index < lisLength; ++index) {
            TweenLite.set(lis[index], {
                y: 0,
                opacity: 1
            });
        }

        for(index = 0; index < lisLength; ++index) {
            height += lis[index].offsetHeight;

            width = lis[index].offsetWidth;

            if(width > widest) {
                widest = width;
            }

            TweenLite.to(lis[index], animate ? duration + (index * this.options.stagger) : 0, {
                y: -height,
                opacity: 0,
                ease: Power3.easeOut
            });
        }

        TweenLite.set(ul, {
            height: height
        });

        TweenLite.set(dropdownTrigger, {
            rotation: 90
        });

        TweenLite.to(ul, animate ? duration + (index * this.options.stagger) : 0, {
            height: 0,
            ease: Power3.easeOut
        });

        TweenLite.to(dropdownTrigger, animate ? 0.2 : 0, {
            rotation: 0,
            ease: Power3.easeOut
        });

        dropdown.classList.remove('open');
    }

    openNavigation() {
        document.body.classList.add('blur-content');

        this.openButton();

        window.requestAnimationFrame(() => {
            document.body.classList.add('navigation-open');

            TweenLite.set(this.elements.navigation, {
                opacity: 0,
                display: 'block'
            });

            TweenLite.set(this.elements.navigationInner, {
                y: -20
            });

            TweenLite.to(this.elements.navigation, 0.4, {
                opacity: 1,
                ease: Power2.easeOut
            });

            TweenLite.to(this.elements.navigationInner, 0.4, {
                y: 0,
                ease: Power2.easeOut
            });
        });
    }

    closeNavigation() {
        document.body.classList.remove('blur-content');

        this.closeButton();

        window.requestAnimationFrame(() => {
            document.body.classList.remove('navigation-open');

            TweenLite.set(this.elements.navigation, {
                opacity: 1,
                display: 'block'
            });

            TweenLite.set(this.elements.navigationInner, {
                y: 0
            });

            TweenLite.to(this.elements.navigation, 0.4, {
                opacity: 0,
                ease: Power2.easeOut,
                onComplete: () => {
                    TweenLite.set(this.elements.navigation, {
                        display: 'none'
                    });
                }
            });

            TweenLite.to(this.elements.navigationInner, 0.4, {
                y: -20,
                ease: Power2.easeOut
            });
        });
    }

    openButton(event) {
        TweenLite.to(this.elements.bars[1], 0.2, {
            opacity: 0,
            ease: Power3.easeOut,
            onComplete: () => {
                TweenLite.to(this.elements.bars[0], 0.2, {
                    y: 11,
                    rotation: 45,
                    ease: Power3.easeOut
                });

                TweenLite.to(this.elements.bars[2], 0.2, {
                    y: -10.5,
                    rotation: -45,
                    ease: Power3.easeOut
                });
            }
        });
    }

    closeButton(event) {
        TweenLite.to(this.elements.bars[0], 0.2, {
            y: 0,
            rotation: 0,
            ease: Power3.easeOut
        });

        TweenLite.to(this.elements.bars[2], 0.2, {
            y: 0,
            rotation: 0,
            ease: Power3.easeOut
        });

        TweenLite.to(this.elements.bars[1], 0.2, {
            opacity: 1,
            ease: Power3.easeOut,
        });
    }
}

export default MobileNavController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/mobile-nav.js